import { j as s } from "../accordion/Accordion-CrPiD_81.mjs";
import { forwardRef as g } from "react";
const i = g(
  ({ className: a = "", label: d, ratio: r, checkmarkOnDone: e = !1, animateIn: t = !1, ...o }, p) => {
    const l = { "--progress": r };
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": "rds-progress__wrapper",
        className: `rds-progress ${t ? "rds-progress--animate" : ""} ${a}`,
        children: [
          /* @__PURE__ */ s.jsxs("label", { "data-testid": "rds-progress__label", className: "sr-only", children: [
            /* @__PURE__ */ s.jsx("progress", { "data-testid": "rds-progress__sr", max: 1, value: r, ref: p, ...o }),
            d
          ] }),
          r === 1 && e && /* @__PURE__ */ s.jsx("div", { "data-testid": "rds-progress__mark", className: "rds-progress--done" }),
          (r !== 1 || !e) && /* @__PURE__ */ s.jsx("div", { className: "rds-progress__track", children: /* @__PURE__ */ s.jsx("div", { "data-testid": "rds-progress__bar", style: l, className: "rds-progress__progress" }) })
        ]
      }
    );
  }
);
i.displayName = "Progress";
export {
  i as P
};
